import React from "react"

import { Box, Typography } from "components/common"
import YotpoGetInspired from "components/yotpo-get-inspired"
import { LinkButton } from "jewlr/pages/components"

const GetInspired = () => {
  if (!sl.config.use_yotpo) {
    return false
  }

  return (
    <Box
      contain
      id="GetInspired"
      mb={5}
      mt={4}
      px={{ _: "5px" }}
      textAlign="center"
    >
      <Typography fontFamily="main" fontSize={20} fontWeight="bold">
        GET INSPIRED
      </Typography>
      <Typography
        fontSize={{ _: 16, tablet: 20 }}
        fontWeight="light"
        italic
        mt={1}
      >
        See what our customers are creating. <br />
        Shop the look to personalize and make it yours.
      </Typography>
      <YotpoGetInspired />
      <LinkButton outline="text" px={5} sz="sm" to="/all-jewelry">
        SHOP ALL
      </LinkButton>
    </Box>
  )
}

export default GetInspired
